import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Terminal, ArrowRight, Mail } from "lucide-react";
import { API } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      // Backend always returns 200 to prevent enumeration; only network errors land here
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-6" data-testid="forgot-password-page">
      <div className="w-full max-w-md panel relative">
        <div className="border-b border-zinc-900 px-6 py-3 flex items-center gap-2">
          <Terminal className="w-4 h-4 text-[#FFB000]" />
          <span className="font-heading font-black tracking-tighter">DARA</span>
          <span className="font-mono text-[10px] text-zinc-500 ml-auto">AUTH://forgot</span>
        </div>

        {sent ? (
          <div className="p-8 space-y-5" data-testid="forgot-password-success">
            <div className="font-mono text-[10px] uppercase tracking-widest text-[#FFB000] mb-2">// LINK SENT</div>
            <h1 className="font-heading font-black text-3xl tracking-tighter uppercase">Check your inbox.</h1>
            <p className="font-mono text-[12px] text-zinc-400 leading-relaxed">
              If an account exists for <span className="text-white">{email}</span>, you&apos;ll receive a reset link within 60 seconds. The link expires in 1 hour.
            </p>
            <p className="font-mono text-[11px] text-zinc-500 leading-relaxed pt-2 border-t border-zinc-900">
              Didn&apos;t arrive? Check spam, then{" "}
              <button
                type="button"
                onClick={() => setSent(false)}
                data-testid="forgot-password-retry-btn"
                className="text-[#FFB000] hover:underline"
              >
                try again
              </button>.
            </p>
            <Link to="/login" className="block text-center font-mono text-[11px] text-zinc-500 hover:text-white pt-2" data-testid="forgot-password-back-link">
              ← Back to login
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="p-8 space-y-5">
            <div>
              <div className="font-mono text-[10px] uppercase tracking-widest text-zinc-500 mb-3">// PASSWORD RESET</div>
              <h1 className="font-heading font-black text-3xl tracking-tighter uppercase">
                Forgot your<br />password?
              </h1>
              <p className="font-mono text-[11px] text-zinc-500 mt-3 leading-relaxed">
                Enter your DARA email. We&apos;ll send a single-use reset link that expires in 1 hour.
              </p>
            </div>

            <label className="block">
              <span className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">Email</span>
              <input
                data-testid="forgot-password-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@company.com"
                className="mt-2 w-full bg-black border border-zinc-800 px-3 py-2.5 font-mono text-sm text-white focus:outline-none focus:border-[#FFB000]"
              />
            </label>

            <button
              type="submit"
              disabled={loading}
              data-testid="forgot-password-submit-btn"
              className="w-full bg-[#FFB000] text-black font-bold font-mono text-xs uppercase tracking-wider py-3 hover:bg-[#E59E00] transition-colors flex items-center justify-center gap-2 disabled:opacity-50"
            >
              {loading ? "SENDING…" : <><Mail className="w-4 h-4" /> Send reset link <ArrowRight className="w-4 h-4" /></>}
            </button>

            <Link to="/login" className="block text-center font-mono text-[11px] text-zinc-500 hover:text-white pt-2" data-testid="forgot-password-back-link">
              ← Back to login
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
